import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { AllAPIResponses, CarbonError } from './../../../index';

type Payload = {
  all?: boolean;
  email: string;
  reason: string;
  tokean: string;
};

const del = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  try {
    const resp = await req.del(
      `/api/usersubscriptions/unsubscribe`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: {},
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default del;
